import BasePolicy from '@/policies/BasePolicy.js';

export default class AttendancePolicy extends BasePolicy {
    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    viewAny(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'view all attendances') ||
            user.hasGroupPermissionWithinCourse(course, 'view all attendances') ||
            user.isStudentSupportOfCourse(course.id)
        );
    }

    /**
     * @param {User} user
     * @param {Attendance} attendance
     * @returns boolean
     */
    view(user, attendance) {
        return user.hasPermissionViaCourseTo(attendance.course, 'view an attendance');
    }

    /**
     * @param {User} user
     * @param {Attendance} attendance
     * @returns boolean
     */
    viewDetails(user, attendance) {
        return user.isGroupInstructorOf(attendance.course_id);
    }

    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    'view audit'(user, course) {
        const globalAuditRoles = ['Attendance Manager', 'Student Support', 'Instruction Admin'];

        if (
            globalAuditRoles.some(role => user.hasRole(role)) &&
            user.hasPermissionTo('view attendance audit log')
        ) {
            return true;
        }

        return user.hasPermissionViaCourseTo(course, 'view attendance audit log');
    }

    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    create(user, course) {
        const permission = 'create an attendance';

        return user.hasPermissionTo(permission) || user.hasUnlimitedScopePermissionTo(permission);
    }

    /**
     * @param {User} user
     * @param {Attendance} attendance
     * @returns boolean
     */
    update(user, attendance) {
        return user.hasPermissionViaCourseTo(attendance.course, 'edit an attendance');
    }

    /**
     * @param {User} user
     * @param {Attendance} attendance
     * @returns boolean
     */
    delete(user, attendance) {
        return user.hasPermissionViaCourseTo(attendance.course, 'delete an attendance');
    }
}
